/**
 * Pluggable error reporter for the SPA.
 * Register via `setErrorReporter(fn)` at startup (see `src/main.jsx`).
 */

/** @type {null | ((err: unknown, ctx?: object) => void)} */
let reporter = null

/** @param {(err: unknown, ctx?: object) => void} fn */
export function setErrorReporter(fn) {
  reporter = typeof fn === 'function' ? fn : null
}

/** @param {unknown} err @param {object} [ctx] */
export function reportError(err, ctx) {
  if (!reporter) {
    if (import.meta.env.DEV) {
      console.warn('[errorReporter] no reporter registered; would have reported:', err, ctx)
    }
    return
  }
  try {
    reporter(err, ctx)
  } catch (innerErr) {
    if (import.meta.env.DEV) {
      console.error('[errorReporter] reporter threw:', innerErr)
    }
  }
}
